import React from "react";
import PageHero from "../components/PageHeader";
import { FAQ as FAQ_LIST, PAGE_HEROES } from "../data/site";

export default function FAQ() {
  const hero = PAGE_HEROES.faq;
  return (
    <div data-testid="faq-page" className="bg-[#f7f4ec]">
      <PageHero image={hero.image} title={hero.title} subtitle={hero.subtitle} testId="faq-hero" />

      <section className="max-w-3xl mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-24">
        <div className="border-t border-[#e3ddcf]">
          {FAQ_LIST.map((item, i) => (
            <details
              key={i}
              className="faq-item border-b border-[#e3ddcf]"
              data-testid={`faq-item-${i}`}
            >
              <summary>
                <h3 className="font-serif text-2xl md:text-3xl text-[#13263c] leading-snug">
                  {item.q}
                </h3>
                <span className="plus" aria-hidden="true">+</span>
              </summary>
              <div className="answer">
                <p className="text-[#4a4a4a] leading-relaxed text-base md:text-lg">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </section>
    </div>
  );
}
